$(document).ready(function() {

   var $slider = jQuery(".slider");

// if ($slider.length) {
//   let currentSlide;
//   let slidesCount;
//   let sliderCounter = document.createElement("div");

//   $slider.slick({
//     dots: false,
//     autoplay: false,
//     autoplaySpeed: 3000,
//     pauseOnFocus: false,
//     pauseOnHover: false,
//     arrows: true,
//     cssEase: "linear",
//     slidesToShow: 3, // Default to 3 slides shown at a time
//     slidesToScroll: 1, // Scroll one slide at a time
//     infinite: true, // Allow infinite scrolling
//     variableWidth: false, // Ensure slides are of equal width
//     responsive: [
//       {
//         breakpoint: 1100, 
//         settings: {
//           slidesToShow: 2, // Show 1 slide at a time
//           slidesToScroll: 2, // Scroll one slide at a time
//           arrows: true, // Optionally hide arrows on smaller screens
//         }
//       },
//       {
//         breakpoint: 768, // At 768px or less
//         settings: {
//           slidesToShow: 2, // Show 1 slide at a time
//           slidesToScroll: 2, // Scroll one slide at a time
//           arrows: true, // Optionally hide arrows on smaller screens
//         }
//       },
//       {
//       breakpoint: 480,
//         settings: { 
//           slidesToScroll: 1,
//           slidesToShow: 1,
//           centerMode: false,
//           centerPadding: '0',
//           adaptiveHeight: true,
//           arrows: true,
//         }
//       }
//     ]
//   });

//   function progress(sliders) {
//     sliders.each(function () {
//       var slider = jQuery(this);
//       var $progressBar = slider
//         .parentsUntil(".variable_slider_row")
//         .find(".progress");

//       slider.on(
//         "beforeChange",
//         function (event, slick, currentSlide, nextSlide) {
//           var calc = ((nextSlide + 1) / slick.slideCount) * 100;
//           $progressBar.css("background-size", calc + "% 100%");
//         }
//       );
//     });
//   }

//   progress($slider);
// }
 setTimeout(function(){
	$drawerRight = $('.cart-drawer-right');
	$cart_list = $('.cart-drawer-btn, .cart-drawer-close-btn');
		
	$cart_list.click(function() {
    let closeClick = document.querySelector('[data-js-menu-button][aria-expanded="true"]');
    if (closeClick) {
      closeClick.click();
      console.log('click close');
    }
		$(this).toggleClass('active');
		$('body').toggleClass('cart-drawer-pushtoleft');
		$drawerRight.toggleClass('cart-drawer-open');
	});
   }, 1500);
});


$(document).ready(function() {
  // Function to check and hide the .number span
  function checkCartCount() {
    var cartCount = parseInt($('[data-js-cart-count]').text());

    // Hide the .number span if the cart count is 0
    if (cartCount === 0) {
      $('.number').hide();
    }
  }

  // Initial check when the page loads
  checkCartCount();

  // When the remove button is clicked, update the cart count and check again
  $(document).on('click', '[data-remove-item]', function() {
    // Assuming the cart count is updated dynamically, call the check function
    setTimeout(function() {
      checkCartCount(); // Check the cart count after item removal
    }, 500); // Delay to wait for the cart count to update (adjust if needed)
  });
});


document.addEventListener("DOMContentLoaded", function() {
  // Check if the current URL path is "/cart"
  if (window.location.pathname === "/cart") {
    // Select elements with the specified class
    console.log("you are in cart page")
    const cartIcons = document.querySelectorAll(".header__icon-touch.no-transition.cart-drawer-btn");

    // Apply pointer-events: none to each selected element
    cartIcons.forEach(icon => {
      icon.style.pointerEvents = "none";
    });
  }
});
